export default [
  {
    name: '购买成功',
    path: '/kids/payed',
    component: () => import('@/components/common/payed/PaySuccessed.vue'),
    alias: ['/kids/ulink/payed'],
    meta: { alias: ['/kids/ulink/payed'] },
  },
  {
    name: '会员中心',
    path: '/kids/membership-purchase',
    component: () => import('@/views/kids/membership-purchase/MembershipPurchase.vue'),
    alias: ['/kids/ulink/membership-purchase'],
    meta: { alias: ['/kids/ulink/membership-purchase'] },
  },
  {
    name: '会员中心-鸿蒙测试临时用',
    path: '/kids/membership-purchase-hm-test',
    component: () => import('@/views/kids/membership-purchase-hm-test/MembershipPurchase.vue'),
    alias: ['/kids/ulink/membership-purchase-hm-test'],
    meta: { alias: ['/kids/ulink/membership-purchase-hm-test'] },
  },
];
